import { ZipBoxOutlineIcon } from './ZipBoxOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 19E804D8-154F-4250-82D3-76F5401B5674
 * name zip-box-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zip-box-outline.svg
 * tags
 * - Files / Folders 
 */
export const CompressedFileOutlineIcon = ZipBoxOutlineIcon;
export default CompressedFileOutlineIcon